import React from 'react';
import CrudPage from '../../components/CrudPage';
import { withdrawalTransactionApi } from '../../services/adminApi';

const columns = [
  { header: 'ID', field: 'withdrawalTransactionId' },
  { header: 'Investor ID', field: 'investorId' },
  { header: 'Amount', field: 'amount', render: (v) => v ? `£${v.toLocaleString()}` : '-' },
  { header: 'Status', field: 'status' },
  { header: 'Bank Account', field: 'bankAccount' },
  { header: 'Created', field: 'createdAt', type: 'date' },
];

const formFields = [
  { name: 'investorId', label: 'Investor ID', type: 'text', required: true },
  { name: 'amount', label: 'Amount', type: 'number', required: true },
  { name: 'bankAccount', label: 'Bank Account', type: 'text' },
  { name: 'notes', label: 'Notes', type: 'textarea' },
];

const WithdrawalTransactionPage = () => (
  <CrudPage
    title="Withdrawal Transactions"
    subtitle="Manage withdrawal requests (create only)"
    api={withdrawalTransactionApi}
    columns={columns}
    formFields={formFields}
    idField="withdrawalTransactionId"
    disableEdit={true}
    disableDelete={true}
  />
);

export default WithdrawalTransactionPage;
